import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum BrcodeType {
  Cpf = 1,
  Cnpj = 2,
  Email = 3,
  Phone = 4,
  Account = 5,
  RandomKey = 6,
}
EnumDescriptions.setDescriptions(BrcodeType, [
  i18n.t('enums.cpf'),
  i18n.t('enums.cnpj'),
  i18n.t('enums.email'),
  i18n.t('enums.phone'),
  i18n.t('enums.account'),
  i18n.t('enums.random_key'),
]);
